export const PERIODS = {
    "Previous period": "previous_period",
    "Previous month": "previous_month",
    "Previous year": "previous_year",
    "Custom": "custom"
};

export const VALID_PERIODS = Object.values(PERIODS);